import { ServiceChargeCalculatedAt } from 'src/types/AddMerchant/merchantInfo';

export const BANKING_DETAILS_INITIAL_VALUES = {
    serviceChargeCalculatedAt: ServiceChargeCalculatedAt.GROUPLEVEL,
    bankIdentifierCode: '',
    internationalBankAccountNumber: '',
    accountName: '',
    bankName: '',
};

export const OUTLET_INITIAL_VALUES = {
    name: '',
    tradingAddress: {
        eircode: '',
        addressLine1: '',
        addressLine2: '',
        townOrCity: '',
        country: '',
        county: '',
    },
    siteContact: {
        firstName: '',
        lastName: '',
        email: '',
        mobileNumber: '',
        telephoneNumber: '',
        position: '',
    },
    bankingDetails: BANKING_DETAILS_INITIAL_VALUES,
};

export const ABOUT_BUSINESS_INITIAL_VALUES = {
    businessType: '',
    legalCompanyName: '',
    website: '',
    registeredNumber: '',
    tradingName: '',
    isCharity: false,
    charityNumber: '',
    registeredAddress: {
        eircode: '',
        addressLine1: '',
        addressLine2: '',
        townOrCity: '',
        country: '',
        county: '',
    },
    vat: {
        vatRegistered: false,
        vatNumber: '',
        vatVerified: false,
    },
};
